import React from "react";
import { Card, Skeleton } from "@mui/material";
import { Stack } from "@mui/system";

const TourCardSkeleton = () => (
  <Card
    data-testid="tour-card-skeleton"
    sx={{
      minWidth: 300,
      height: 500,
      display: "flex",
      flex: 1,
      flexDirection: "column",
      justifyContent: "space-between",
      borderRadius: 2,
      backgroundColor: "primary.contrastText"
    }}
  >
    <Skeleton variant="rectangular" width="100%" height={300} />
    <Stack spacing={2} sx={{ padding: 2 }} useFlexGap>
      <Skeleton variant="text" width="40%" height={40} />
      <Skeleton variant="text" width="60%" height={20} />
      <Skeleton variant="text" width="60%" height={20} />
      <Skeleton
        variant="rectangular"
        width={150}
        height={40}
        sx={{ mt: 4, borderRadius: 5, alignSelf: "flex-end" }}
      />
    </Stack>
  </Card>
);

export default TourCardSkeleton;
